import React from "react"
import PropTypes from "prop-types"
import { Button, Flex } from "antd"
import { PlusOutlined } from "@ant-design/icons"
import { Text } from "ui/Typography"
import { useTranslation } from "react-i18next"
import EquipmentTable from "../EquipmentTable"
import styles from "./index.module.css"

const AssignedEquipmentSection = ({ equipment, onUnassign, onToggleAdd }) => {
  const { t } = useTranslation()

  const handleUnassign = (item) => {
    onUnassign(item.id)
  }

  return (
    <div className={styles.section}>
      <Flex align="center" gap={8} className="mb-xl">
        <Text fw={600} size="xl">
          {t("booking.equipment.assigned_equipment")}
        </Text>
        <Text className={styles.countText}>({equipment.length})</Text>
      </Flex>

      <Flex vertical gap={12}>
        <EquipmentTable
          equipment={equipment}
          onAction={handleUnassign}
          actionType="unassign"
          emptyMessage={t("booking.equipment.no_assigned_equipment")}
        />

        <div className="px-xl">
          <Button type="link" icon={<PlusOutlined />} className={styles.addButton} onClick={onToggleAdd}>
            {t("booking.equipment.add_equipment_button")}
          </Button>
        </div>
      </Flex>
    </div>
  )
}

AssignedEquipmentSection.propTypes = {
  equipment: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number.isRequired,
      name: PropTypes.string.isRequired,
      assetNumber: PropTypes.string.isRequired,
      category: PropTypes.string.isRequired
    })
  ).isRequired,
  onUnassign: PropTypes.func.isRequired,
  onToggleAdd: PropTypes.func.isRequired
}

export default AssignedEquipmentSection
